import { QuestionnaireConfigState, ConfigurableQuestionnaireKey } from "./models";
import { QuestionnaireConfigAction, QUESTIONNAIRE_CONFIG_ADDITIONAL_QUESTION_ADDED, QUESTIONNAIRE_CONFIG_ADDITIONAL_QUESTION_REMOVED } from "./actionTypes";
import { QUESTIONNAIRE_CONFIG_LOADED, QUESTIONNAIRE_CONFIG_SAVED } from "./actionTypes";

export const questionnaireConfig = (state: QuestionnaireConfigState = {}, action: QuestionnaireConfigAction) => {
    switch (action.type) {
        case QUESTIONNAIRE_CONFIG_LOADED:
        case QUESTIONNAIRE_CONFIG_SAVED: {
            return {
                ...state,
                [action.payload.questionnaireType]: {
                    questions: action.payload.questions || [],
                    additionalQuestions: action.payload.additionalQuestions || []
                }
            };
        }
        case QUESTIONNAIRE_CONFIG_ADDITIONAL_QUESTION_ADDED: {
            const existingConfig = state[action.payload.questionnaireType] || { questions: [], additionalQuestions: [] };
            return {
                ...state,
                [action.payload.questionnaireType]: {
                    ...existingConfig,
                    additionalQuestions: [
                        ...existingConfig.additionalQuestions,
                        action.payload.questionAdded
                    ]
                }
            };
        }
        case QUESTIONNAIRE_CONFIG_ADDITIONAL_QUESTION_REMOVED: {
            const existingConfig = state[action.payload.questionnaireType as ConfigurableQuestionnaireKey] || { questions: [], additionalQuestions: [] };
            return {
                ...state,
                [action.payload.questionnaireType]: {
                    ...existingConfig,
                    additionalQuestions: existingConfig.additionalQuestions.filter(q => q.id !== action.payload.questionId)
                }
            };
        }
        default: {
            return state;
        }
    }
};
